jQuery("#back-top").hide();
jQuery(function () {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1000) {
            jQuery('#back-top').fadeIn();
            jQuery("#back-top").addClass('active');
        } else {
            jQuery('#back-top').fadeOut();
            jQuery("#back-top").removeClass('active');
        }
    });
    jQuery('#back-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});




/********************** Mobile menu ********************** */
jQuery(document).on("click", ".navbar-toggler,.close-menu", function (e) {
    jQuery(jQuery(this).attr('data-target')).toggleClass("show");
});


function lazyloader() {
    const lazyContent = new LazyLoad({
        elements_selector: ".lazy"
    });

    const lazyBackground = new LazyLoad({
        elements_selector: "iframe.lazy, video.lazy, div.lazy, section.lazy, button.lazy,header.lazy"
    });
}


$(document).ready(function () {
    lazyloader();

    $('#toggleMenu').on('click', function () {
        $('.primary-menu-wrapper').toggleClass('openmenu');
        $('.header-navigation').toggleClass('open-menu');
    });

    $('.menuCloseIcon').on('click', function () {
        $('.primary-menu-wrapper').removeClass('openmenu');
        $('.header-navigation').removeClass('open-menu');
    });


    /**********************footer menu ********************** */

    jQuery(document).on("click", ".menu-collapse-container .menu-collapse-title", function (e) {
        jQuery(this).parents(".menu-collapse-container").find(".menu-collapse-wrap").slideToggle("slow");
    });

    $('.reviews-slider').slick({
        slidesToShow: 3,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: false,
        prevArrow: $('.reviews-prev'),
        nextArrow: $('.reviews-next'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
    $('.homepage-projects-slider').slick({
        slidesToShow: 4,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: false,
        variableWidth: false,
        prevArrow: $('.homepage-projects-prev'),
        nextArrow: $('.homepage-projects-next'),
        lazyLoad: 'ondemand',
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnTouch: true,
        pauseOnScroll: true,
        pauseOnClick: true,
        pauseOnDrag: true,
        pauseOnSwipe: true,
        pauseOnScroll: true,
        pauseOnScroll: true,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });

    $('.projects-slider').slick({
        slidesToShow: 3,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        cssEase: 'linear',
        infinite: true,
        focusOnSelect: false,
        dots: false,
        variableWidth: true,

        prevArrow: $('.projects-prev'),
        nextArrow: $('.projects-next'),
    });

    $('.gallery-slider').slick({
        slidesToShow: 5,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 4000,
        centerMode: true,
        variableWidth: true,
        centerPadding: '20px',
        touchMove: true,
        touchThreshold: 10,
        touchMoveTolerance: 10,
        touchMovePropagation: true,
        touchMovePropagation: true,
        focusOnSelect: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnTouch: false,
        pauseOnScroll: false,
        pauseOnClick: false,
        pauseOnDrag: false,
        pauseOnSwipe: false,
        pauseOnScroll: false,
        pauseOnScroll: false,
        lazyLoad: 'ondemand',
    });
    if ($(window).width() < 767) {
        $(".mobile-slider-partial").slick({
            slidesToShow: 2,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            speed: 500,
            cssEase: 'linear',
            infinite: true,
            variableWidth: true,
        });
    }

    let currentX = 0; // percentage
    const minX = -12.5;
    const maxX = 14;
    const step = 1.6;

    const scrollDiv = document.getElementById('scrollDiv');
    let isVisible = false;

    if (scrollDiv) {

        // Observe visibility
        const observer = new IntersectionObserver(
            ([entry]) => {
                isVisible = entry.isIntersecting;
            },
            {
                threshold: 0.3 // 30% visible before activating
            }
        );

        observer.observe(scrollDiv);

        window.addEventListener(
            'wheel',
            (e) => {
                if (!isVisible) return; // 🚫 do nothing if not visible

                if (e.deltaY > 0) {
                    // Scroll down → move left
                    currentX = Math.max(minX, currentX - step);
                } else {
                    // Scroll up → move right
                    currentX = Math.min(maxX, currentX + step);
                }

                scrollDiv.style.transform = `translateX(${currentX}%)`;
            },
            { passive: true }
        );
    }
});
function copyEmail(btn, email) {
    console.log(btn, email);
    navigator.clipboard.writeText(email).then(() => {
        const text = $('.copy-text span');
        const original = text.html();
        text.text('COPIED!');
        text.addClass('text-green-400');

        setTimeout(() => {
            text.text(original);
            text.removeClass('text-green-400');
        }, 5000);
    });
}


jQuery(document).ready(function ($) {

    function getUrlParam(param) {
        const url = window.location.href.split('#')[0];
        const urlParams = new URLSearchParams(url.split('?')[1]);
        return urlParams.get(param);
    }

    let projectId = getUrlParam('project_id');

    function updateUrl(sector = '') {
        let url = window.location.pathname;

        if (sector) {
            url += '?sector=' + sector;
        }

        history.pushState({}, '', url);
    }

    function loadProjects(reset = false) {

        let button = $('#load-more');
        let page = reset ? 1 : button.data('page');
        let sector = $('.sector-btn.active').data('sector') || '';

        $.ajax({
            url: projectsAjax.ajaxUrl,
            type: 'POST',
            data: {
                action: 'load_projects',
                page: page,
                sector: sector,
                project_id: projectId,
                nonce: projectsAjax.nonce
            },
            beforeSend: function () {
                button.text('Loading...');
            },
            success: function (response) {

                if (reset) {
                    $('#projects-list').html(response);
                } else {
                    if (response != 'no-more') {
                        $('#projects-list').append(response);
                    }
                }

                // Hide load more only when viewing single project
                if (projectId || response === 'no-more') {
                    button.hide();
                } else {
                    button
                        .show()
                        .text('load more projects')
                        .data('page', page + 1);
                }
            }
        });

        lazyloader();
    }

    // 🔹 Initial load
    if ($('#projects-list').length) {

        if (projectId) {
            // Single project view
            $('#load-more').hide();
            $('.sector-btn').removeClass('active');
            // 🔹 Scroll to projects list
            scrollToProjects();
        } else {
            $('#load-more').data('page', 1).show();
        }

        loadProjects(true);
    }

    // 🔹 Load more
    $(document).on('click', '#load-more', function () {
        loadProjects();
    });

    // 🔹 Sector filter click
    $(document).on('click', '.sector-btn', function () {

        // Clear single project mode
        projectId = null;

        $('.sector-btn').removeClass('active');
        $(this).addClass('active');

        $('#load-more')
            .data('page', 1)
            .show();

        const sector = $(this).data('sector') || '';
        updateUrl(sector);

        loadProjects(true);
    });
    function scrollToProjects() {
        const target = document.getElementById('projects-list');
        if (!target) return;

        const offset = 120; // adjust if you have sticky header
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top: top,
            behavior: 'smooth'
        });
    }
    const $header = $('header'); // or $('#headerNav')

    $(window).on('scroll', function () {
        if ($(this).scrollTop() > 50) {
            $header.addClass('is-scrolled');
        } else {
            $header.removeClass('is-scrolled');
        }
    });
});
